<template>
  <div class="after_sale_info_warp">
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">收货信息</div>
      </div>
      <div class="card_content">
        <el-descriptions>
          <el-descriptions-item label="联系姓名">{{ orderInfo.buyName }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ orderInfo.buyPhone }}</el-descriptions-item>
          <el-descriptions-item label="联系地址">
            {{ orderInfo.buyCountryName }}
            {{ orderInfo.buyProvinceName }}
            {{ orderInfo.buyCityName }}
            <span v-if="orderInfo.buyAreaName">{{ orderInfo.buyAreaName }}</span>
            {{ orderInfo.buyAddress }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">订单信息</div>
      </div>
      <div class="card_content">
        <el-descriptions>
          <el-descriptions-item label="订单编号">{{ orderInfo.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{
            formatApiDate(orderInfo.orderTime) || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="用户姓名">{{ orderInfo.userName }}</el-descriptions-item>
          <el-descriptions-item label="用户手机号">{{ orderInfo.mobile }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{ orderInfo.remark }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">售后操作日志</div>
      </div>
      <div class="card_content operation-log-list">
        <el-timeline v-if="orderInfo.operationLogs && orderInfo.operationLogs.length">
          <el-timeline-item
            v-for="log in orderInfo.operationLogs"
            :key="log.id || `${log.operation}-${log.ctdate}`"
            :timestamp="formatApiDate(log.ctdate)"
            placement="top"
          >
            <el-card shadow="never">
              <strong>{{ log.operation || "售后操作" }}</strong>
              <p v-if="log.operatorName || log.operatorId">
                操作人：{{ log.operatorName || `用户 ${log.operatorId}` }}
              </p>
              <p v-if="log.remark">备注：{{ log.remark }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <el-empty v-else description="暂无操作日志" :image-size="70" />
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">售后商品信息</div>
      </div>
      <div class="card_content">
        <el-table :data="orderInfo.items" style="width: 100%" size="mini">
          <el-table-column prop="id" label="明细编号" width="120"></el-table-column>
          <el-table-column prop="goodsId" label="商品编号" width="120"></el-table-column>
          <!--          <el-table-column-->
          <!--            prop="expressNo"-->
          <!--            label="卖家发货单号"-->
          <!--            width="180"-->
          <!--          ></el-table-column>-->
          <el-table-column prop="title" label="商品名称"> </el-table-column>
          <el-table-column label="商品条目" min-width="220">
            <template slot-scope="scope">
              <div class="sku-cell">
                <div>{{ scope.row.skuName || scope.row.goodsSpece || "-" }}</div>
                <div class="sku-spec" v-if="formatSkuSpec(scope.row)">
                  {{ formatSkuSpec(scope.row) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="mainGraph" label="商品图" width="100">
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.skuImage || scope.row.mainGraph"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="expressTime" label="卖家发货时间">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span>{{ formatApiDate(scope.row.expressTime) }}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column-->
          <!--            prop="expressName"-->
          <!--            label="卖家发货快递"-->
          <!--          ></el-table-column>-->
          <el-table-column prop="unitPrice" label="商品单价"> </el-table-column>
          <el-table-column prop="buyNum" label="商品数量"> </el-table-column>
          <el-table-column prop="goodsAmount" label="商品总金额"> </el-table-column>
        </el-table>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">售后</div>
      </div>
      <div class="card_content">
        <el-descriptions title="售后信息" border class="descriptions_mar_warp">
          <el-descriptions-item label="售后状态">{{
            getValue(AFTER_SALE_STATUS, orderInfo.status)
          }}</el-descriptions-item>
          <el-descriptions-item label="售后类型">{{
            getValue(AFTER_SALE_TYPE, orderInfo.type)
          }}</el-descriptions-item>
          <el-descriptions-item label="售后原因">{{
            getValue(AFTER_SALE_REASON, orderInfo.reason)
          }}</el-descriptions-item>
          <el-descriptions-item label="退款金额"
            >{{ orderInfo.refundAmount }}元</el-descriptions-item
          >
          <el-descriptions-item label="凭证图片">{{ orderInfo.proofImg }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{ orderInfo.remark }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="买家寄回物流" border class="descriptions_mar_warp">
          <el-descriptions-item label="发货单号"
            ><span @click="onExpressNo" style="cursor:pointer">{{
              orderInfo.expressNo
            }}</span></el-descriptions-item
          >
          <el-descriptions-item label="发货时间">
            {{ formatApiDate(orderInfo.expressTime) }}
          </el-descriptions-item>
          <el-descriptions-item label="快递公司">{{ orderInfo.expressName }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{ orderInfo.expressRemark }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="卖家收货地址" border class="descriptions_mar_warp">
          <el-descriptions-item label="联系电话">{{ orderInfo.salePhone }}</el-descriptions-item>
          <el-descriptions-item label="联系姓名">{{ orderInfo.saleName }}</el-descriptions-item>
          <el-descriptions-item label="详细地址">
            {{ orderInfo.saleCountryName }}
            {{ orderInfo.saleProvinceName }}
            {{ orderInfo.saleCityName }}
            <span v-if="orderInfo.saleAreaName">{{ orderInfo.saleAreaName }}</span>
            {{ orderInfo.saleAddress }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
    <div class="dialog-footer">
      <el-button type="primary" @click="returnList">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getOrderAfterDetail } from "@/api/order";
import { formatApiDate } from "@/utils/utils";
import { getValue, AFTER_SALE_REASON, AFTER_SALE_STATUS, AFTER_SALE_TYPE } from "@/utils/enumUtile";

export default {
  name: "orderInfo",
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    AFTER_SALE_REASON() {
      return AFTER_SALE_REASON;
    },
    AFTER_SALE_STATUS() {
      return AFTER_SALE_STATUS;
    },
    AFTER_SALE_TYPE() {
      return AFTER_SALE_TYPE;
    }
  },
  data() {
    return {
      id: 0,
      orderInfo: {}, // 订单详情
      listLoading: false
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.id = id;
      this.getList();
    }
  },
  watch: {},
  methods: {
    getValue,
    onExpressNo() {
      window.open(
        "https://www.baidu.com/s?rsv_idx=1&wd=%E6%9F%A5%E5%BF%AB%E9%80%92%E5%8D%95%E5%8F%B7%E6%9F%A5%E8%AF%A2%E5%85%A5%E5%8F%A3",
        "_blank"
      );
    },
    getList() {
      const id = this.id;
      if (!id) {
        return;
      }
      this.listLoading = true;
      const params = {
        id
      };
      getOrderAfterDetail(params)
        .then(response => {
          console.log(response);
          this.orderInfo = response.data || [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    formatSkuSpec(row) {
      if (!row || !row.specValuePath) {
        return "";
      }
      try {
        const spec = JSON.parse(row.specValuePath);
        return Object.keys(spec)
          .map(key => `${key}: ${spec[key]}`)
          .join("; ");
      } catch (e) {
        return row.goodsSpece || "";
      }
    },
    returnList() {
      this.$router.push({ path: `/order/afterSale?isDetailPage=${true}` });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/index";

.after_sale_info_warp {
  background-color: #eeeeee;
  padding: 20px;
  height: calc(100vh - 124px);
  overflow-y: auto;

  .box-card {
    margin-bottom: 20px;
  }

  .card_title {
    display: flex;
    align-items: center;

    .card_title_fg {
      height: 22px;
      width: 4px;
      background-color: $Theme-color;
    }

    .card_title_msg {
      margin-left: 6px;
    }
  }

  .card_content {
    margin-top: 10px;

    .descriptions_mar_warp {
      margin-top: 20px;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: end;
  }

  .sku-cell {
    line-height: 1.5;
  }

  .sku-spec {
    margin-top: 4px;
    color: #909399;
    font-size: 12px;
  }

  .operation-log-list p {
    margin: 8px 0 0;
    color: #606266;
  }
}
</style>
